import { render } from "./ChannelPackageList_c.vue?vue&type=template&id=fabf54a4"
import script from "./ChannelPackageList_c.vue?vue&type=script&lang=js"
export * from "./ChannelPackageList_c.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__